import React from "react";

import { TextContainer } from "./styles";

export default function CardInformation({ title, content }) {
  return (
    <TextContainer>
      <b>{title}_:</b> <span>{content}</span>
    </TextContainer>
  );
}
